import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUserShield, FaEnvelope, FaLock } from "react-icons/fa";

const ADMIN_CREDENTIALS = {
  email: "admin@linkinprofessionals.com",
  password: "Admin@123",
};

function AdminLogin() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError("");
  };

  const handleLogin = (e) => {
    e.preventDefault();

    if (
      formData.email.trim().toLowerCase() ===
        ADMIN_CREDENTIALS.email.toLowerCase() &&
      formData.password === ADMIN_CREDENTIALS.password
    ) {
      localStorage.setItem("adminAuth", "true");

      localStorage.setItem(
        "adminUser",
        JSON.stringify({
          name: "Administrator",
          email: ADMIN_CREDENTIALS.email,
        })
      );

      navigate("/admin/dashboard");
    } else {
      setError("Invalid Email or Password");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-blue-900 via-purple-900 to-indigo-900 flex items-center justify-center px-4">
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden">
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white text-center py-8">
          <FaUserShield className="mx-auto text-6xl mb-4" />
          <h1 className="text-4xl font-bold">Admin Login</h1>
          <p className="mt-2 text-blue-100">
            Linkin Professionals Dashboard
          </p>
        </div>

        <form onSubmit={handleLogin} className="p-8">
          {error && (
            <div className="mb-6 bg-red-100 text-red-700 px-4 py-3 rounded-lg">
              {error}
            </div>
          )}

          <div className="mb-5">
            <label className="block text-gray-700 font-semibold mb-2">
              Email
            </label>
            <div className="relative">
              <FaEnvelope className="absolute top-4 left-4 text-gray-400" />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
                className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <div className="mb-6">
            <label className="block text-gray-700 font-semibold mb-2">
              Password
            </label>
            <div className="relative">
              <FaLock className="absolute top-4 left-4 text-gray-400" />
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter your password"
                required
                className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <button
            type="submit"
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-4 rounded-xl font-bold text-lg hover:opacity-90 transition duration-300"
          >
            Login
          </button>

          
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;